import Logo from '@/components/Logo'
import Account from '@/sinister/header/components/Account'
import Cart from '@/sinister/header/components/Cart'
import Categories from '@/sinister/header/components/Categories'
import CustomPages from '@/sinister/header/components/CustomPages'
import Favorites from '@/sinister/header/components/Favorites'
import Helper from '@/sinister/header/components/Helper'
import OpModel from '@/sinister/header/components/OpModel'
import { useHeaderContext } from '@/sinister/header/contexts/HeaderContext'

import Search from '@mercadoni/sinister/dist/cjs/search'

import { Suspense } from 'react'
import styles from './A.module.css'

const LayoutA = () => {
  const {
    maxItemsInline,
    store: { reference },
    langConfig,
    parsedHelpers,
    initialSearchValue,
    clientId,
    onClickSearch,
    onClickSuggested,
    placeholder,
    pathname,
    enabledSearchAutocomplete,
    initialCategories,
    logo,
    slug,
    domain,
  } = useHeaderContext()

  const langEnabled = langConfig?.enabled || false
  const helperEnabled = !!parsedHelpers?.length

  const secondaryClassName = `${styles.secondary} ${
    helperEnabled ? styles.helperEnabled : styles.helperDisabled
  } ${langEnabled ? styles.langEnabled : styles.langDisabled}`

  return (
    <header className={`${styles.grid} header`}>
      <div className={`${styles.main} header__main`}>
        <Logo
          className={`${styles.logo} header__logo`}
          src={logo}
          slug={slug}
          domain={domain}
          height={50}
        />
        <Categories
          className={`${styles.categoryTree} header__categoryTree`}
          initialCategories={initialCategories}
        />
        <Suspense fallback="">
          <Search
            enabledSearchAutocomplete={enabledSearchAutocomplete}
            className={`${styles.search} header__search`}
            storeReference={reference}
            initialValue={initialSearchValue}
            clientId={clientId}
            onClickSearch={onClickSearch}
            onClickSuggested={onClickSuggested}
            placeholder={placeholder}
            pathname={pathname}
          />
        </Suspense>
        <Account className={`${styles.account} header__account`} />
        <div className={`${styles.icons} header__icons`}>
          <Favorites />
          <Cart />
        </div>
      </div>
      <div className={`${secondaryClassName} header__secondary`}>
        <OpModel />
        <CustomPages maxItemsInline={maxItemsInline || 6} />
        <Helper />
      </div>
    </header>
  )
}

export default LayoutA
